import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { signout } from '../helpers/auth'
import { signOut } from '../reducers/user'
import Search from './Search'
import logo from '../images/logo.svg'
import wordmark from '../images/wordmark.svg'

class Header extends Component {
  constructor (props) {
    super(props);

    this.state = {
      mobileNav: false
    }
  }

  handleSignout = () => {
    // Sign out of app
    signout()

    // Redux sign out
    this.props.signOut()
  }

  showMenu = () => {
    if (this.state.mobileNav === false) {
      this.setState({
        mobileNav: true
      })
    } else {
      this.setState({
        mobileNav: false
      })
    }
  }

  closeMenu = () => {
    if (this.state.mobileNav === true) {
      this.setState({
        mobileNav: false
      })
    }
  }

  render () {

    const logoStyle = {
      height: '18px',
      marginRight: '8px'
    }

    const wordStyle = {
      height: '18px'
    }

    return (
      <header className="bg-blue flex-ns justify-between-ns">

        <div className="flex items-center">
          <div className="logo pa2 pl3 pr0 flex items-center justify-center">
            <Link to="/">
              <img alt="logo" src={logo} style={logoStyle} className="mr2-ns" onClick={this.closeMenu}/>
              <img alt="Polaris" src={wordmark} style={wordStyle} className="dn dib-ns pr3-ns" onClick={this.closeMenu}/>
            </Link>
          </div>

          <div className="pa2 h3 flex items-center justify-center flex-auto flex-none-ns w5-ns">
            {this.props.authed ? <Search /> : null }
          </div>
          
          <div className="pa2 h3 flex items-center justify-center dn-ns">
            <i className="material-icons white" onClick={this.showMenu}>menu</i>
          </div>
        </div>
        <div className="white">
</div>
        <div className="flex-ns items-center-ns">
          <ul className={`list ma0 pr2-ns pa0 white dib-ns ${this.state.mobileNav ? '' : 'dn'}`}>
            {
              this.props.authed ? (
                <span>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <Link to="/dashboard" className="white link" onClick={this.closeMenu}>Plans</Link>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <a href="https://www.youtube.com/channel/UC-W9UUlH2nzyB7lyH0KszxA?view_as=subscriber" target="_blank" rel="noopener noreferrer" className="white link" onClick={this.closeMenu}>YouTube</a>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <a href="https://www.dropbox.com/sh/wiguecridixzsz5/AADib8HQ1qD5PgxEJmlsSkJva?dl=0" target="_blank" rel="noopener noreferrer" className="white link" onClick={this.closeMenu}>DropBox</a>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                  <Link to="/blogs" className="white link" onClick={this.closeMenu}>Blogs</Link>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                  <form action="https://polarisinvesting.us19.list-manage.com/subscribe/post?u=b70cf30d32402c73db8841faa&amp;id=c99f037c6b" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
	<h4> &nbsp;
    <input type="submit" value="Get Tips" name="subscribe" id="mc-embedded-subscribe" class="button" className="white link bg-transparent b--none-ns" >
    </input></h4>
</form> </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <Link to="/" onClick={this.handleSignout} className="white link">Sign out</Link>
                  </li>
                </span>
              ) : (
                <span>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <Link to="/pricing" className="white link" onClick={this.closeMenu}>Pricing</Link>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <a href="https://www.youtube.com/channel/UC-W9UUlH2nzyB7lyH0KszxA?view_as=subscriber" target="_blank" rel="noopener noreferrer" className="white link" onClick={this.closeMenu}>YouTube</a>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <a href="https://www.dropbox.com/sh/wiguecridixzsz5/AADib8HQ1qD5PgxEJmlsSkJva?dl=0" target="_blank" rel="noopener noreferrer" className="white link" onClick={this.closeMenu}>DropBox</a>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                  <Link to="/blogs" className="white link" onClick={this.closeMenu}>Blogs</Link>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                  <form action="https://polarisinvesting.us19.list-manage.com/subscribe/post?u=b70cf30d32402c73db8841faa&amp;id=c99f037c6b" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate> 
                  <h4> &nbsp;
    <input type="submit" value="Get Tips" name="subscribe" id="mc-embedded-subscribe" class="button">
    </input></h4>
</form>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <Link to="/aboutus" className="white link" onClick={this.closeMenu}>About Us</Link>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <Link to="/login" className="white link" onClick={this.closeMenu}>Sign in</Link>
                  </li>
                  <li className="pa3 pa2-ns bt b--white-20 b--none-ns dib-ns">
                    <Link to="/register" className="white link" onClick={this.closeMenu}>Register</Link>
                  </li>
                </span>
              )
            }
          </ul>
        </div>
        
        
      </header>
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.user.currentUser,
  }),
  {signOut}
)(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js